import React, { createContext, useEffect, useMemo, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useQuery } from '../../hooks/use-query';

const now = new Date();
const initialYear = now.getFullYear() - (now.getMonth() < 8 ? 1 : 0);
const Context = createContext();

export const useContext = () => React.useContext(Context);

export function YieldContext({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = useQuery();
  const [year, setYear] = useState(
    Number(queryParams.get('year')) || initialYear,
  );
  const [tab, setTab] = useState(queryParams.get('tab') || 'clean');

  useEffect(() => {
    navigate(`${location.pathname}?year=${year}&tab=${tab}`, {
      replace: true,
    });
  }, [year, tab, navigate, location.pathname]);

  const state = useMemo(
    () => ({
      year,
      setYear,
      tab,
      setTab,
    }),
    [year, tab],
  );

  return <Context.Provider value={state}>{children}</Context.Provider>;
}
